import React, { useState } from "react";
import destinations from "../data/destinations.json";
import { Link } from "react-router-dom";

const Destinations = () => {
  const [selectedType, setSelectedType] = useState("Any");
  const [selectedSeason, setSelectedSeason] = useState("Any");
  const [selectedContinent, setSelectedContinent] = useState("Any");

  // Filter destinations based on selected filters
  const filteredDestinations = destinations.filter((destination) => {
    return (
      (selectedType === "Any" || destination.type === selectedType) &&
      (selectedSeason === "Any" || destination.season === selectedSeason) &&
      (selectedContinent === "Any" || destination.continent === selectedContinent)
    );
  });

  return (
    <div className="flex flex-col justify-center lg:flex-row container mx-auto">
      {/* Sidebar */}
      <aside className="lg:w-1/4 bg-gray-100 p-4">
        <h2 className="text-lg font-bold mb-4">Filters</h2>

        {/* Type Filter */}
        <div className="mb-6">
          <h3 className="text-sm font-bold mb-2">Type</h3>
          <select
            className="w-full p-2 border rounded"
            value={selectedType}
            onChange={(e) => setSelectedType(e.target.value)}
          >
            <option value="Any">Any</option>
            <option value="City">City</option>
            <option value="Beach">Beach</option>
            <option value="Nature">Nature</option>
          </select>
        </div>

        {/* Season Filter */}
        <div className="mb-6">
          <h3 className="text-sm font-bold mb-2">Season</h3>
          <select
            className="w-full p-2 border rounded"
            value={selectedSeason}
            onChange={(e) => setSelectedSeason(e.target.value)}
          >
            <option value="Any">Any</option>
            <option value="Spring">Spring</option>
            <option value="Summer">Summer</option>
            <option value="Fall">Fall</option>
            <option value="Winter">Winter</option>
          </select>
        </div>

        {/* Continent Filter */}
        <div>
          <h3 className="text-sm font-bold mb-2">Continent</h3>
          <select
            className="w-full p-2 border rounded"
            value={selectedContinent}
            onChange={(e) => setSelectedContinent(e.target.value)}
          >
            <option value="Any">Any</option>
            <option value="Europe">Europe</option>
            <option value="Asia">Asia</option>
            <option value="North America">North America</option>
            <option value="South America">South America</option>
            <option value="Africa">Africa</option>
            <option value="Australia">Australia</option>
          </select>
        </div>
      </aside>

      {/* Main Content */}
      <main className="lg:w-3/4 p-4">
        <h2 className="text-lg font-bold mb-4">
          We've found you {filteredDestinations.length} holidays
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2  gap-4">
          {filteredDestinations.map((destination) => (
            <div
              key={destination.id}
              className="bg-white shadow-lg rounded-lg overflow-hidden"
            >
              {/* Image */}
              <img
                src={destination.image}
                alt={destination.name}
                className="w-full h-48 object-cover"
              />

              {/* Content */}
              <div className="p-4">
                <h3 className="text-xl font-bold">{destination.name}</h3>
                <p className="text-gray-600 text-sm mb-2">
                  {destination.description}
                </p>

                {/* Attributes */}
                <div className="text-sm text-gray-500">
                  <p>
                    <strong>Type:</strong> {destination.type}
                  </p>
                  <p>
                    <strong>Season:</strong> {destination.season}
                  </p>
                  <p>
                    <strong>Continent:</strong> {destination.continent}
                  </p>
                </div>

                <Link
    to={`/destinations/${destination.name.toLowerCase()}`}
    className="mt-4 w-full inline-block bg-blue-500 text-white py-2 text-center rounded hover:bg-blue-600"
  >
    See More Details
  </Link>
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
};

export default Destinations;
